module.exports = __webpack_public_path__ + "static/media/read-again.7e0eff5e.png";